import type { SupportedLanguage } from "@/generated/fastapi";

export const SUPPORTED_LANGUAGE_EN = "en" as const;
export const SUPPORTED_LANGUAGE_DE = "de" as const;
export const SUPPORTED_LANGUAGE_SK = "sk" as const;

export const SUPPORTED_LANGUAGE_CODES = [
  SUPPORTED_LANGUAGE_EN,
  SUPPORTED_LANGUAGE_DE,
  SUPPORTED_LANGUAGE_SK,
] as const;

export const supportedLanguages: Record<SupportedLanguage, string> =
  Object.freeze({
    [SUPPORTED_LANGUAGE_EN]: "English",
    [SUPPORTED_LANGUAGE_DE]: "German",
    [SUPPORTED_LANGUAGE_SK]: "Slovak",
  });
